import { site } from "../content/site";

export const Marquee = () => {
  const items = [...site.marquee, ...site.marquee];
  return (
    <div className="overflow-hidden border-y border-gray-200 bg-white py-4" aria-hidden="true" data-testid="services-marquee">
      <div className="animate-marquee flex w-max items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="px-6 text-xs font-semibold uppercase tracking-[0.2em] text-gray-400">
              {item}
            </span>
            <span className="h-1 w-1 rounded-full bg-brand" />
          </span>
        ))}
      </div>
    </div>
  );
};
